import { useState, useEffect } from 'react'
import { InvoiceDocument } from '../types/invoice'

export function useDraftState(
  invoiceId: string,
  baseDocument: InvoiceDocument,
) {
  const [document, setDocument] = useState<InvoiceDocument>(baseDocument)
  const [originalDocument, setOriginalDocument] =
    useState<InvoiceDocument>(baseDocument)
  const [hasDraft, setHasDraft] = useState(false)

  // Reset when invoice changes
  useEffect(() => {
    setDocument(baseDocument)
    setOriginalDocument(baseDocument)
    setHasDraft(false)
  }, [invoiceId, baseDocument])

  const saveDraft = (
    updatedDocumentOrUpdater:
      | InvoiceDocument
      | ((prev: InvoiceDocument) => InvoiceDocument),
  ) => {
    if (typeof updatedDocumentOrUpdater === 'function') {
      // Functional update
      setDocument((prev) => {
        const updated = updatedDocumentOrUpdater(prev)
        setHasDraft(true)
        return updated
      })
    } else {
      // Direct update
      setDocument(updatedDocumentOrUpdater)
      setHasDraft(true)
    }
  }

  const clearDraft = () => {
    setDocument(originalDocument)
    setHasDraft(false)
  }

  const submitDraft = () => {
    setOriginalDocument(document)
    setHasDraft(false)
    return document
  }

  return {
    document,
    originalDocument,
    hasDraft,
    saveDraft,
    clearDraft,
    submitDraft,
  }
}
